const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      } 
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

const collectionNavigationStateKey = 'monsieurParisCollectionNavigation';

const getCollectionGrid = () => document.querySelector('#ProductGridContainer .load-more-grid');

const getCollectionUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  return `${url.pathname}${url.search}`;
}

const saveCollectionNavigationState = () => {
  const grid = getCollectionGrid();
  const currentPageInput = document.querySelector('#ProductGridContainer [data-current-page]');

  if (!grid || !currentPageInput) return;

  const currentState = history.state && typeof history.state === 'object' ? history.state : {};
  history.replaceState({
    ...currentState,
    [collectionNavigationStateKey]: {
      url: getCollectionUrl(),
      page: parseInt(currentPageInput.value, 10) || 1,
      scrollY: window.scrollY
    }
  }, '');
}

const getPageUrl = (urlValue, page) => {
  const url = new URL(urlValue, window.location.origin);
  url.searchParams.set('page', page);
  return url.toString();
}

const appendCollectionPage = async (url, targetGrid) => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Unable to restore collection page: ${response.status}`);
  }

  const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
  const responseGrid = responseDocument.querySelector('#ProductGridContainer .load-more-grid');

  if (!responseGrid) {
    throw new Error('Unable to find the product grid while restoring the collection.');
  }

  targetGrid.insertAdjacentHTML('beforeend', responseGrid.innerHTML);
}

const restoreCollectionNavigationState = async () => {
  const savedState = history.state?.[collectionNavigationStateKey];
  const grid = getCollectionGrid();
  const container = document.getElementById('ProductGridContainer');
  const currentPageInput = container?.querySelector('[data-current-page]');
  const totalPagesInput = container?.querySelector('[data-total-pages]');
  const nextUrlInput = container?.querySelector('[data-next-url]');

  if (
    !savedState ||
    savedState.url !== getCollectionUrl() ||
    !grid ||
    !currentPageInput ||
    !totalPagesInput ||
    !nextUrlInput
  ) return;

  const currentPage = parseInt(currentPageInput.value, 10) || 1;
  const totalPages = parseInt(totalPagesInput.value, 10) || 1;
  const targetPage = Math.min(parseInt(savedState.page, 10) || 1, totalPages);

  if (targetPage <= currentPage) return;

  const previousScrollRestoration = history.scrollRestoration;
  const loader = container.querySelector('.js-load-more, .js-infinite-scroll');
  history.scrollRestoration = 'manual';
  loader?.setAttribute('disabled', '');
  loader?.classList.add('loading');

  try {
    for (let page = currentPage + 1; page <= targetPage; page += 1) {
      await appendCollectionPage(getPageUrl(nextUrlInput.value, page), grid);
      currentPageInput.value = page;
      currentPageInput.dataset.currentPage = page;
    }

    if (typeof colorSwatches === 'function') colorSwatches();

    if (targetPage >= totalPages) {
      container.querySelector('.js-load-more, .js-infinite-scroll')?.remove();
    } else {
      const nextUrl = getPageUrl(nextUrlInput.value, targetPage + 1);
      nextUrlInput.value = nextUrl;
      nextUrlInput.dataset.nextUrl = nextUrl;
      loader?.removeAttribute('disabled');
      loader?.classList.remove('loading');
    }

    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    window.scrollTo(0, savedState.scrollY || 0);
  } catch (error) {
    console.warn(error);
    loader?.removeAttribute('disabled');
    loader?.classList.remove('loading');
  } finally {
    window.setTimeout(() => {
      history.scrollRestoration = previousScrollRestoration;
    }, 0);
  }
}

document.addEventListener('click', (event) => {
  if (event.target.closest('#ProductGridContainer .load-more-grid a')) {
    saveCollectionNavigationState();
  }
}, true);

window.addEventListener('pagehide', saveCollectionNavigationState);

(async function () {
  await restoreCollectionNavigationState();
  loadMore();
})();
